import { useEffect } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { getRoomDetails } from '@/redux/asyncThunks/room'
import { fetchCharterStatus } from '../../redux/asyncThunks/charterThunks'
import { selectTeamStatuses, selectTeamName } from '../../redux/selectors/charterSelectors'
import { GroupMonitorView } from '../../components/Professor/GroupMonitorView'

export default function CharterGroupMonitorPage() {
  const dispatch = useAppDispatch()
  const { roomId = '', teamId = '' } = useParams<{ roomId: string; teamId: string }>()
  const [searchParams] = useSearchParams()

  const currentRoom = useAppSelector((s) => s.room.currentRoom)
  const teamStatuses = useAppSelector(selectTeamStatuses)
  const wsTeamName = useAppSelector(selectTeamName)

  // Hydrate currentRoom after a hard reload so the invite code can fall back
  // to it when the URL param is missing.
  useEffect(() => {
    if (roomId && currentRoom?.roomid !== roomId) {
      dispatch(getRoomDetails(roomId))
    }
  }, [dispatch, roomId, currentRoom?.roomid])

  // Populate teamStatuses on reload so the team name resolves from REST data.
  useEffect(() => {
    if (roomId) {
      dispatch(fetchCharterStatus({ roomId }))
    }
  }, [dispatch, roomId])

  const inviteCode = searchParams.get('inviteCode') || currentRoom?.invite_code || ''
  const urlTeamName = searchParams.get('teamName') ?? ''

  const teamName =
    teamStatuses.find((ts) => String(ts.team_id) === teamId)?.team_name ||
    wsTeamName ||
    urlTeamName ||
    teamId

  return (
    <div className='h-full w-full'>
      <GroupMonitorView
        teamId={teamId}
        teamName={teamName}
        roomId={roomId}
        inviteCode={inviteCode}
      />
    </div>
  )
}
